export const PRODUCT_EVENTS = {
  VIEW_SCREEN: "view_screen",
  SELECT_LINK: "select_link",
  SELECT_SHARE_PRODUCT: "web_select_share_product",
  SELECT_BUY_NOW: "web_select_buy_now",
  SELECT_VARIATION: "web_select_variation",
  OUT_OF_STOCK: "out_of_stock_warning",
  PRODUCT_ADDITIONAL_CONTENT: "product_additional_content",
};
